// Native
import { useState } from "react";
import { useNavigate } from "react-router"

// Components
import { Button, ButtonGroup, Center, Divider, ModalBody, ModalFooter, Stack, Text, useDisclosure, useToast } from "@chakra-ui/react"
import { Alert, Form, Lottie, Modal } from "components"

// Config
import { API, Mask } from "config"

// Screens
import { Authenticate } from "screens"

export default function Register({ onSuccess = () => {}, ...props }){

    const toast = useToast()
    const navigate = useNavigate()
    const [ form, setForm ] = useState({})
    const [ errors, setErrors ] = useState()
    const [ loading, setLoading ] = useState()
    const auth = useDisclosure()

    const onChange = ({ target }) => {
        const { name, value } = target
        switch(name){
            case 'doc_cpf': setForm({...form, [name]: Mask.cpf(value)}); break;
            case 'dob': setForm({...form, [name]: Mask.date(value)}); break;
            case 'mobile': setForm({...form, [name]: Mask.mobile(value)}); break;
            default: setForm({...form, [name]: value}); break;
        }
    }

    const handleSubmit = async () => {
        setLoading(true)
        setErrors(null)

        try{
            const callback = await API.post('/employees', form)
            toast({ title: 'Funcionário registrado', status: 'success' })
            onSuccess()
            navigate(`/employees/${callback?.data?.id}`)
        }catch(err){
            setErrors(err?.response?.data?.errors)
            toast({ title: 'Não foi possível registrar o funcionário.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    return(
    <>
    <Modal {...props}>
        <ModalBody>
            <Stack spacing={4}>

                <Lottie animation="employees" style={{ height: 200, transform: 'scale(1.3)' }} />
                <Center><Text fontSize="lg" fontWeight="bold" children="Registrar Funcionário" /></Center>

                <Divider />

                <Form.Form onSubmit={auth.onOpen}>

                    <Form.Text
                        required
                        label="CPF:"
                        name="doc_cpf"
                        value={form?.doc_cpf}
                        error={errors?.doc_cpf}
                        placeholder="Ex.: 999.999.999-99"
                        onChange={onChange}
                        size="lg"
                        fontWeight="bold"
                        isDisabled={loading}
                    />

                    <Form.Text
                        required
                        label="Data de nascimento:"
                        name="dob"
                        value={form?.dob}
                        error={errors?.dob}
                        onChange={onChange}
                        isDisabled={loading}
                    />

                    <Divider />

                    <Form.Text
                        required
                        label="Nome:"
                        name="name"
                        error={errors?.name}
                        value={form?.name}
                        onChange={onChange}
                        isDisabled={loading}
                        size="lg"
                        fontWeight="bold"
                    />

                    <Form.Text
                        required
                        label="Cargo/Função:"
                        name="tagline"
                        value={form?.tagline}
                        error={errors?.tagline}
                        onChange={onChange}
                        isDisabled={loading}
                        placeholder="Ex.: Suporte de Consultores"
                        size="sm"
                    />

                    <Form.Text
                        required
                        type="email"
                        label="Endereço de e-mail:"
                        name="email"
                        error={errors?.email}
                        value={form?.email}
                        onChange={onChange}
                        isDisabled={loading}
                        size="lg"
                        fontWeight="bold"
                        placeholder="Ex.: funcionario@bonificaoficial.com"
                        helper="Este e-mail será utilizado para acessar o sistema e para recebimento de notificações importantes."
                    />

                    <Form.Text
                        required
                        type="tel"
                        label="Celular:"
                        name="mobile"
                        error={errors?.mobile}
                        value={form?.mobile}
                        onChange={onChange}
                        isDisabled={loading}
                        size="lg"
                        fontWeight="bold"
                        placeholder="Ex.: 62 9 9999 9999"
                    />

                    <Alert children="Você poderá configurar as permissões de acesso do funcionário após criá-lo." />
                    <Alert status="warning">A senha padrão para novos funcionários é <b>bn@2024</b>.</Alert>
                </Form.Form>
            </Stack>
        </ModalBody>

        <ModalFooter>
            <ButtonGroup size="sm" isDisabled={loading}>
                <Button children="Registrar funcionário" isLoading={loading} onClick={auth.onOpen} />
                <Button children="Cancelar" colorScheme="red" onClick={props.onClose} />
            </ButtonGroup>
        </ModalFooter>
    </Modal>

    <Authenticate {...auth} onSuccess={handleSubmit} />
    </>
    )
}